import AbstractOptionsModal from 'components/pages/login/layout/AbstractOptionsModal';
import { Registry } from '@lightningjs/sdk';
import { translate } from 'support/translate';
import { LoginFlow } from '../layout/AbstractLoginModal';

const AUTO_REDIRECT_TIMER = 5000;

export default class SignInConfirmationModal extends AbstractOptionsModal {
  override _showBackButton = false;
  override _showSkipButton = false;

  override get loginFlow() {
    return LoginFlow.SIGN_IN;
  }

  private _autoRedirectTimer: number | null = null;

  override _init() {
    super._init();
    this.checkmarkIconVisible = true;
    this.headingText = translate('account.signin.signInConfirmationHeading');
    this.subHeadingText = translate(
      'account.signin.signInConfirmationSubheading',
    );

    this.optionItems = [
      {
        label: translate('account.signin.signInConfirmationStartWatching'),
        action: '$startWatching',
        passSignals: { $startWatching: '$startWatching' },
      },
    ];
    this.optionSignals = {
      $startWatching: '$startWatching',
    };
  }

  override _enable() {
    super._enable();

    this._autoRedirectTimer = Registry.setTimeout(() => {
      this.$startWatching();
    }, AUTO_REDIRECT_TIMER);
  }

  override _inactive() {
    this.clearTimer();
  }

  override _handleBack() {
    this.$startWatching();
  }

  private clearTimer() {
    if (this._autoRedirectTimer) {
      Registry.clearTimeout(this._autoRedirectTimer);
      this._autoRedirectTimer = null;
    }
  }

  private $startWatching() {
    this.clearTimer();
    this.closeAllLogin();
  }
}
